import { Stripe, loadStripe } from "@stripe/stripe-js";

let stripePromise: Stripe | null;

const initializeStripe = async () => {
  if (!stripePromise) {
    stripePromise = await loadStripe(
      "pk_live_51R9pqxH9z0ThRFdKJYPczQJ243faRKbRX0ooyi0TXQwUdlZpeY1HW9R0ay9BW3eDyJUY6z0iVMEi3ImqwXZ5073200luTvkWyD"
    );
  }
  return stripePromise;
};

export default initializeStripe;
